import script from "./SudoLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./SudoLogin.vue?vue&type=script&setup=true&lang=js"

import "./SudoLogin.vue?vue&type=style&index=0&id=c56de794&scoped=true&lang=css"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c56de794"]])

export default __exports__